import { cx } from '@platform/core/lib/cx';
import type { IControlProps } from '../IControlProps';

/**
 * Число (UIUX/field-types/number): нативне числове поле — нечислове введення відкидається; одиниці — у підписі поля
 * («Залишилось (год)»); у формі вирівнювання ліворуч, у клітинці таблиці (inline) — праворуч моноширинним; порожнє — null.
 */
export function NumberInput({ value, onChange, readOnly, id, size = 'md', invalid, placeholder, autoFocus }: IControlProps<number | string>) {
  return (
    <input id={id} type="number" inputMode="decimal" step="any" className={cx('control', 'fc-num', size !== 'md' && `fc--${size}`, readOnly && 'control--ro')}
      value={value ?? ''} readOnly={readOnly} aria-invalid={invalid || undefined} placeholder={placeholder} autoFocus={autoFocus}
      onChange={(e) => {
        const raw = e.target.value;
        if (raw === '') { onChange(null); return; }
        const n = Number(raw);
        if (Number.isFinite(n)) onChange(n);
      }} />
  );
}
